<template>
  <div class="rule-home">
    <a-spin :spinning="spinning">
      <breadcrumbs :breadcrumbsData="breadcrumbsDataComputed" #icon>
        <svg class="icon" aria-hidden="true" style="fill: #fff">
          <use xlink:href="#icon-a-shezhi2"></use>
        </svg>
      </breadcrumbs>
       <artmisads-segmented-tabs
      v-model="activeTab"
      :items="programConfig"
      :disabled="spinning"
      @change="onChangeTab"
    />
      <div class="content">
        <div class="rule-wrap">
          <pulic-report-notice v-if="showNotice" :class="'rule'" type="urgent" @click="closeNotice" >
            <template #title>{{ st('settingsCommissionRule.noticeExclusivePublisherRate') }}</template>
            <template #close></template>
          </pulic-report-notice>
          <div class="btn">
            <artmisads-button type="primary" size="middle" @click="() => setShowModal(true)">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-jiahao"></use>
              </svg>
              {{ st('settingsCommissionRule.btnAddNewRule') }}
            </artmisads-button>
          </div>
          <ruleTemp
            :list="list"
            :getData="getData"
            :defaultCommission="defaultCommission"
            :activeTab="activeTab"
          />
          <div class="rule-pagination" v-if="listTotal > 0">
            <artemisads-pagination
              :change="onChangePage"
              :pagination="{
                total: listTotal,
                current: params.page,
                pageSize: params.size,
                showSizeChanger: true
              }"
            />
          </div>
        </div>
      </div>
      <editRuleModal
        :modalData="modalData"
        :setShowModal="setShowModal"
        :defaultCommission="defaultCommission"
        :activeTab="activeTab"
        v-if="showModal"
      />
    </a-spin>
  </div>
</template>
<script setup>
  import { ref, onMounted, watch, onBeforeMount, computed } from "vue";
  import { connectionApi } from "@/server/seller/index";
  import { productsApi } from '@/server/index'
  import editRuleModal from './editRuleModal.vue';
  import breadcrumbs from "../../breadcrumbs.vue";
  import ruleTemp from './ruleTemp.vue';
  import PulicReportNotice from "@/components/PulicReportNotice.vue";
import { useSystemStore } from '@/storeData/system'
import { useRouter } from 'vue-router'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
const router = useRouter()
const modalData=ref({})
  const activeTab = ref('0')
  const systemStore = useSystemStore()
  /** 暂时隐藏 Commission rule 页 Associate 标签页 */
  const HIDE_ASSOCIATE_COMMISSION_RULE_TAB = true
  const programConfig = computed(() => {
    const info = systemStore.programConfig
    if (!info?.length) return info
    let list = info
    if (HIDE_ASSOCIATE_COMMISSION_RULE_TAB) {
      list = info.filter((item) => item.key !== '1')
    }
    return list.map((item) => {
      const base = { ...item }
      if (item.key === '0') base.label = st('common.amazonAttribution')
      return base
    })
  })
  const breadcrumbsDataComputed = computed(() => ({
    title: st('settingsCommissionRule.pageTitle'),
    color: "#776D91",
    links: [
      {
        name: st('common.home'),
        path: "/seller/dashboard",
      },
      {
        name: st('settingsConnections.breadcrumbSettings'),
        path: "/seller/connection",
      },
      {
        name: st('settingsCommissionRule.pageTitle'),
        path: "/seller/commission-rule",
      },
    ],
  }))
  const showNotice = ref(false);
  const showModal = ref(false);
  const defaultCommission = ref({
    defaultCommissionRate: 1,
    platformFeeFactor: 1,
    platformMaxFeeRate: 1,
    platformType:''
  })
  const params = ref({
    page: 1,
    size: 10,
    businessType:"Attribution"
  })
  const listTotal = ref(0);
  const list = ref([]);
  const spinning = ref(false);

  const onChangePage = (data) => {
    const { current, pageSize } = data;
    params.value.page = current;
    params.value.size = pageSize;
  }

  watch(params.value, () => {
    getData();
  })
  const onChangeTab = (data) => {
    params.value.businessType = activeTab.value === '0' ? 'Attribution' : 'Associate';
    params.value.page = 1;
    params.value.size = 10;
    getRate()
  }
  const getData = async () => {
    spinning.value = true;
    params.value.businessType = activeTab.value === '0' ? 'Attribution' : 'Associate';
    const res = await connectionApi.getSellerSettingsCommissionRuleList(params.value);
    const { success, data } = res;
    if (success) {
      list.value = data.data;
      listTotal.value = data.total;
    }
    spinning.value = false;
  };

  const setShowModal = (status, reload) => {
    showModal.value = status;
    if (reload) {
      getData()
    }
  }

  const closeNotice = () => {
    localStorage.setItem('SELLER_COMMISSION_RULE_SHOW_NOTICE', '1');
    showNotice.value = false;
  }

  onBeforeMount(() => {
    showNotice.value = localStorage.getItem('SELLER_COMMISSION_RULE_SHOW_NOTICE') !== '1';
  })

  const getRate = async () => {
    let param={
      commissionType:""
    }
    if(activeTab.value == '1'){
      param.commissionType = 'Associate'
    }else{
      param.commissionType = 'Attribution'
    }
    const res = await productsApi.getCommissionConfig(param)
    const { success, data } = res
    if (success) {
      defaultCommission.value = data
    }
  }

  onMounted(() => {
    const publisherId = router.currentRoute.value.query.publisherId
    const creatorName = router.currentRoute.value.query.creatorName
    modalData.value={
     
    }
    if (publisherId && !HIDE_ASSOCIATE_COMMISSION_RULE_TAB) {
      activeTab.value = '1'
      showModal.value = true
      modalData.value.publisherVOList=[{
        id: publisherId,
        creatorName:creatorName
      }]
    }
    getData();
    getRate();
  })

</script>
<style lang="less" scoped>
  .rule-home {
    padding: 0 16px;
    .content {
      display: flex;
      .rule-wrap {
        width: 100%;
      }
    }
    .btn {
      button {
        display: flex;
        svg {
          width: 20px;
          height: 20px;
          align-self: center;
          margin-right: 8px;
        }
      }
    }
    .rule-pagination {
      :deep(.ant-pagination) {
        padding: 16px 16px 16px 16px;
        background-color: var(--color-white);
        box-shadow: var(--section-box-shadow-5);
        border-radius: 8px;
      }
      .pagination {
        display: flex;
        justify-content: flex-end;
        margin-top: 0;
      }
    }
  }
</style>
